import { Navigate, RouterProvider, createBrowserRouter } from "react-router-dom";
import { protectedRoutes } from "./routes/protectedRoutes";
import { publicRoutes } from "./routes/publicRoutes";
import { protectRoutes } from "./routes/routeProtection";
import "./App.css";

const router = createBrowserRouter([
  ...publicRoutes,
  ...protectRoutes(protectedRoutes),
  { path: "*", element: <Navigate to="/" replace /> },
]);

export default function App() {
  return <RouterProvider router={router} />;
}
